
export default {
  state: {
    language: '',
    timezone: ''
  },
  getters: {
    language (state) {
      return state.language
    },
    timezone (state) {
      return state.timezone
    }
  },
  mutations: {
    setLanguage (state, language) {
      state.language = language
    },
    setTimezone (state, timezone) {
      state.timezone = timezone
    }
  },
  actions: {
    setTimezone (context, timezone) {
      context.commit('setTimezone', timezone)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/settings/index.js